import * as React from "react";
import { cn } from "../../lib/utils";
const mapVariant = (variant) => {
    switch (variant) {
        case "secondary":
            return "va-badge--secondary";
        case "destructive":
            return "va-badge--destructive";
        case "outline":
            return "va-badge--outline";
        default:
            return "";
    }
};
function Badge({ className, variant, ...props }) {
    return <div className={cn("va-badge", mapVariant(variant), className)} {...props}/>;
}
export { Badge };
